import React, { useState, useEffect } from 'react';
import './body.css';
import { Link } from 'react-router-dom';

import { FaLaptopCode, FaCapsules, FaAssistiveListeningSystems, FaBookOpen, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { FaGraduationCap, FaChalkboardTeacher, FaHandshake, FaArrowRight, FaUserGraduate, FaBuilding } from 'react-icons/fa';
import { FaCalendarAlt } from 'react-icons/fa';

import {  } from 'react-icons/fa';
import { FaUniversity, FaCertificate, FaLayerGroup, FaTools, FaAward, FaFlask, FaUserTie, FaGlobeAsia, FaIndustry } from 'react-icons/fa';





const programmes = [
  { icon: <FaUniversity />, label: 'Degree' },
  { icon: <FaBuilding />, label: 'HND' },
  { icon: <FaChalkboardTeacher />, label: 'Diploma' },
  { icon: <FaAward />, label: 'Advanced Certificate' },
  { icon: <FaCertificate />, label: 'Certificate' },
  { icon: <FaLayerGroup />, label: 'Foundation' },
  { icon: <FaTools />, label: 'Workshops' },
];   


function Body() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const testimonials = [
    {
      id: 1,
      quote: "APC's curriculum gave me the perfect foundation for my software engineering career at Virtusa.",
      name: "Saman Perera",
      title: "Software Engineer",
      year: "Class of 2019"
    },
    {
      id: 2,
      quote: "The industry-aligned courses helped me secure a position at WSO2 immediately after graduation.",
      name: "Nimali Fernando",
      title: "DevOps Specialist",
      year: "Class of 2020"
    },
    {
      id: 3,
      quote: "The practical projects were exactly what I needed to excel in my current role at IFS.",
      name: "Rajitha Silva",
      title: "Solutions Architect",
      year: "Class of 2018"
    },
    {
      id: 4,
      quote: "APC's international partnerships opened doors for my postgraduate studies in Australia.",
      name: "Chamari Bandara",
      title: "PhD Candidate",
      year: "Class of 2017"
    },
    {
      id: 5,
      quote: "The career guidance services helped me transition from biology to bioinformatics successfully.",
      name: "Anusha Ratnayake",
      title: "Bioinformatics Analyst",
      year: "Class of 2021"
    },
    {
      id: 6,
      quote: "I built my startup using the entrepreneurial skills I gained from APC's business program.",
      name: "Dinesh Gamage",
      title: "Founder, TechStart LK",
      year: "Class of 2020"
    },
        {
      id: 7,
      quote: "The career guidance services helped me transition from biology to bioinformatics successfully.",
      name: "Anusha Ratnayake",
      title: "Bioinformatics Analyst",
      year: "Class of 2021"
    },
    {
      id: 8,
      quote: "I built my startup using the entrepreneurial skills I gained from APC's business program.",
      name: "Dinesh Gamage",
      title: "Founder, TechStart LK",
      year: "Class of 2020"
    }
  ];
  // Auto-advance every 5 seconds
  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        goToNext();
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [currentIndex, isAutoPlaying]);

  const goToPrev = () => {
    setCurrentIndex(prev => (prev - 2 + testimonials.length) % (testimonials.length - 2));
    setIsAutoPlaying(false);
  };

  const goToNext = () => {
    setCurrentIndex(prev => (prev + 2) % (testimonials.length - 2));
    setIsAutoPlaying(false);
  };

  const visibleTestimonials = [];
  for (let i = 0; i < 3; i++) {
    const index = (currentIndex + i) % testimonials.length;
    visibleTestimonials.push(testimonials[index]);
  }












  useEffect(() => {
  const slides = document.querySelectorAll(".slide");
  let current = 0;
  const interval = setInterval(() => {
    slides[current].classList.remove("active");
    current = (current + 1) % slides.length;
    slides[current].classList.add("active");
  }, 5000);
  return () => clearInterval(interval);
}, []);




  return (
    <div className="apc-body">
      {/* Hero Section */}

      <section className="apc-hero">
        <div className="banner-slideshow">
          <img src="banner3.jpg" alt="Banner 1" className="slide active" />
          <img src="lecture.jpg" alt="Banner 2" className="slide" />
        </div>
        <div className="hero-overlay">
          <div className="hero-content-body">
            <h1 >Your Gateway to World-Class Technical Education in Asia</h1>
            <p >
              Shaping the innovators and leaders of tomorrow through cutting-edge education
            </p> 
            <div className="hero-cta">

              {/* <Link to='/programs'>
              <button className="cta-primary">Explore Programs</button>
              </Link> */}

              <Link to='visit'>
              <button className="cta-secondary">Virtual Tour</button>
              </Link>

            </div>
          </div>
        </div>
      </section>






              

 <div className="institute-container">
      <div className="faculty-section">
        <div className="faculty-card">
          <div className="card-banner" style={{ backgroundImage: "url('/computer-center.jpg')" }}></div>
          <h2>Information Technology</h2>
          <div className="faculty-content">
            <p><FaLaptopCode className="faculty-icon" /> Build foundational skills in computing, programming, and digital systems for modern tech careers.</p>
            <Link to='/it-course' className="card-link">
              <button className="more-btn">MORE</button>
            </Link>
          </div>
        </div>

        <div className="faculty-card">
          <div className="card-banner" style={{ backgroundImage: "url('/pharma.jpg')" }}></div>
          <h2>Pharmacology</h2>
          <div className="faculty-content">
            <p><FaCapsules className="faculty-icon" /> Understand how medications work in the body, covering drug actions, effects, and healthcare use</p>
            <Link to='/pharmacology-course' className="card-link">
              <button className="more-btn">MORE</button>
            </Link>
          </div>
        </div>

        <div className="faculty-card">
          <div className="card-banner" style={{ backgroundImage: "url('/audiology-room.webp')" }}></div>
          <h2>Audiology</h2>
          <div className="faculty-content">
            <p><FaAssistiveListeningSystems className="faculty-icon" /> Explore hearing sciences, diagnostic techniques, evaluation, and therapeutic interventions.</p>
            <Link to='/audiology-course' className="card-link">
              <button className="more-btn">MORE</button>
            </Link>
          </div>
        </div>

        <div className="faculty-card">
          <div className="card-banner" style={{ backgroundImage: "url('/innovative.jpeg')" }}></div>
          <h2>English</h2>
          <div className="faculty-content">
            <p><FaBookOpen className="faculty-icon" /> Enhance your communication, writing, and comprehension skills for academic and professional success.</p>
            <Link to='/english-course' className="card-link">
              <button className="more-btn">MORE</button>
            </Link>
          </div>
        </div>
      </div>
    </div>



    <div className="apc-programmes-container">
      <h2 className="title">Asian Polytechnic Campus Programmes</h2>
      <div className="programme-grid">
        {programmes.map((item, index) => (
          <div className="programme-card" key={index}>
            <div className="icon-box">{item.icon}</div>
            <p>{item.label}</p>
          </div>
        ))}
      </div>
    </div>



    


      {/* About Section */}
<section className="apc-about">
  <div className="about-container">
    <div className="about-content">
      <h2 className="about-title">Shape Your Future at Asian Polytechnic Campus</h2>
      
      <div className="about-highlights">
        <div className="highlight-item">
          <div className="highlight-icon">
            <FaGraduationCap />
          </div>
          <p>15+ industry-aligned diploma and degree programs</p>
        </div>
        
        <div className="highlight-item">
          <div className="highlight-icon">
            <FaChalkboardTeacher />
          </div>
          <p>90% of faculty with real-world industry experience</p>
        </div>
        
        <div className="highlight-item">
          <div className="highlight-icon">
            <FaHandshake />
          </div>
          <p>Partnerships with 50+ leading tech companies</p>
        </div>
      </div>
      
      <p className="about-description">
        At Asian Polytechnic Campus (APC), we don't just educate - we transform. As Sri Lanka's fastest-growing 
        technical education provider, we've pioneered an immersive learning model that blends cutting-edge 
        academics with hands-on industry experience. Our state-of-the-art campus in Colombo features 
        next-generation labs, innovation hubs, and collaborative spaces designed to spark creativity and 
        technical mastery.
      </p>
      
      <p className="about-description">
        What sets APC apart is our <strong>Career-Ready Guarantee</strong> - every program includes internships, 
        industry certifications, and career coaching. Our graduates leave not just with qualifications, 
        but with portfolios of real projects and connections to launch rewarding careers. With 87% of our 
        alumni employed within 3 months of graduation, APC is your proven pathway to success in the digital 
        economy.
      </p>
      
      <div className="about-cta">
        <Link to='/aboutus' className="cta-link">
          <button className="cta-learn-more">
            Discover APC <FaArrowRight className="cta-icon" />
          </button>
        </Link>

      </div>
    </div>
    
    <div className="about-image">
      <div className="image-wrapper">
        <img 
          src="/apc-about.jpg" 
          alt="APC Modern Campus Facilities" 
          className="main-image"
        />
      </div>
    </div>
  </div>
</section>

     








 

    <section className="unique-apc">
      <div className="container">
        <div className="section-header">
          <h2>Why Asian Polytechnic Campus Stands Apart</h2>
          <p className="subtitle">Discover the APC difference that prepares graduates for real-world success</p>
          <div className="divider"></div>
        </div>

        <div className="unique-features">
          {/* Feature 1 */}
          <div className="feature-card">
            <div className="feature-icon">
              <FaIndustry />
            </div>
            <h3>Industry-Integrated Curriculum</h3>

          </div>

          {/* Feature 2 */}
          <div className="feature-card">
            <div className="feature-icon">
              <FaGlobeAsia />
            </div>
            <h3>Global Certification Pathways</h3>

          </div>

          {/* Feature 3 */}
          <div className="feature-card">
            <div className="feature-icon">
              <FaUserTie />
            </div>
            <h3>Guaranteed Career Launch</h3>

          </div>

          {/* Feature 4 */}
          <div className="feature-card">
            <div className="feature-icon">
              <FaChalkboardTeacher />
            </div>
            <h3>Practitioner Faculty</h3>

          </div>

          {/* Feature 5 */}
          <div className="feature-card">
            <div className="feature-icon">
              <FaFlask />
            </div>
            <h3>Future-Focused Labs</h3>
 
          </div>

          {/* Feature 6 */}
          <div className="feature-card">
            <div className="feature-icon">
              <FaHandshake />
            </div>
            <h3>Lifetime Career Support</h3>

          </div>
        </div>

      </div>
    </section>







      {/* CTA Section */}
      <section className="apc-cta">
        <div className="cta-container">
          <h2 className='cta-heading'>Ready to Begin Your Journey?</h2>
          <p>Applications for the next academic year are now open. Join our community of innovators and leaders.</p>
          <div className="cta-buttons">
            
            <Link to='/apply'>
            <button className="cta-apply">Apply Now</button>
            </Link>

            <Link to='/admission'>
            <button className="cta-contact">Contact Admissions</button>
            </Link>

          </div>
        </div>
      </section>
    </div>
  );
}

export default Body;